import { useState, useEffect, useRef, useContext } from "react";
import { Row, Col, Button, Form, Alert, Modal, ProgressBar, Card, Table } from "react-bootstrap";

import _ from "lodash";
import axios from "axios";
import moment from "moment";  
import Utils from "../../common/Utils";
import { UserContext } from "../../common";

const RotaAssignment = (props) => {
  const { userData } = useContext(UserContext);
  
  const [rotas,setRotas] = useState(props.data || {});
  const [noteModal, setNoteModal] = useState({show:false,uid:0,type:'',dtStr:''});

  const dtFrom = props.mode===2 ? moment(_.get(props,'defaultDate','')).startOf('week').add(1,'days') : moment(_.get(props,'defaultDate',''));

  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState();

  const title = ["","Create Rota","Edit Rota"];

  const assignRotas = () => {    
    setSaving(true);
    axios
      .post(
        Utils.apiUrl("users/assignRotas"),
        "data="+encodeURIComponent(JSON.stringify(pickSelectedRotas()))+"&defBranch="+props.defBranch,
        Utils.apiHeaders()
      )
      .then((res) => {
        setSaving(false);
        setMessage(res.data.message);
        if(res.data.success) {
          props.afterSave(res.data);
          props.onHide();
        }
      })
      .catch((err) => {
        setSaving(false);
        console.log(err);
      });
  };

  const pickSelectedRotas = () => {
    let rts = {};
    Object.keys(rotas).forEach((uid) => {
      ['fd','am','pm'].forEach((type) => {
        Object.keys(_.get(rotas,[uid,type],{})).forEach((dtStr) => {
          if(_.get(rotas,[uid,type,dtStr,'selected'],false)){
            if(!rts[uid]) rts[uid] = {fd:{},am:{},pm:{}};
            rts[uid][type][dtStr] = {...rotas[uid][type][dtStr]};
          }
        });
      });
    });
    return rts;
  };

  const setRotaDRB = (uid,type,dtStr) => (e) => {
    let rts = {...rotas};
    if(!rts[uid]) rts[uid] = {fd:{},am:{},pm:{}};

    _.set(rts,[uid,type,dtStr,'selected'],e.target.checked);

    if(e.target.checked){
      if(type=='fd'){
        _.set(rts,[uid,'am',dtStr,'selected'],false);
        _.set(rts,[uid,'pm',dtStr,'selected'],false);
      }else{
        _.set(rts,[uid,'fd',dtStr,'selected'],false);
      }
    }
    setRotas(rts);
  };
  

  const saveRotaNote = (e) => {
    e.preventDefault();
    const note = e.target.note.value;
    let rts = {...rotas};
    _.set(rts,[noteModal.uid,noteModal.type,noteModal.dtStr,'notes'],note);
    setRotas(rts);
    setNoteModal({show:false,uid:0,type:'',dtStr:''});
  }

  const renderMemberName = (mem) => mem.title+" "+ mem.name;

  const renderSelectors = (uid,type,dt,cls) => {
    const typeStr = type=='fd' ? "Full Day" : (type=='am' ? "AM" : "PM");
    const dtStr = moment(dt).format("YYYY-MM-DD");
    const selected = _.get(rotas,[uid,type,dtStr,'selected'],false);
    return <div className={`border ${cls} bordered-dark rounded p-1 h-100`}>    
      <Row className="p-1 m-1">
        <Col className="text-start col-2"><Form.Check type="checkbox" id={uid+type+dtStr} onClick={setRotaDRB(uid,type,dtStr)}  checked={selected} /></Col>
        <Col><label for={uid+type+dtStr} className={`d-block clickable btn btn-outline-secondary ${cls} border-0 p-0 text-${selected ? 'center fw-bold' : 'end'}`}>{typeStr}</label></Col>
        {selected && <Col className="text-end col-2 px-2"><img src={`${process.env.PUBLIC_URL}/images/notes.png`} className="clickable" onClick={() =>setNoteModal({show: true,uid,type,dtStr})} /></Col>}
      </Row>
      {selected && <>
        <div>
          <select className="form-select p-0" onChange={(e) => {
            let rts = {...rotas};
            _.set(rts,[uid,type,dtStr,'room'],e.target.value);
            setRotas(rts);
          }} value={_.get(rotas,[uid,type,dtStr,'room'],"")}>
            <option value="">Select Room</option>
            {_.get(process.env,'REACT_APP_ROOM_TYPES','').split(',').map((r,idx) => <option key={idx} value={idx}>{r}</option>)}
          </select>
        </div>
        <div className="pt-1">
          <select className="form-select p-0" onChange={(e) => {
            let rts = {...rotas};
            _.set(rts,[uid,type,dtStr,'branch'],e.target.value);
            setRotas(rts);
          }} value={_.get(rotas,[uid,type,dtStr,'branch'],"")}>
            <option value="">Branch (override)</option>
            {_.get(props,'branches',[]).map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
          </select>
        </div>
      </>}
    </div>;
  }

  const renderMemberCell = (usr,dt) => {
    let cls = 'bg-white';
    if(!usr.wdays.includes(moment(dt).weekday())) {
      cls="leave-day";
    }
    return <div>
      {renderSelectors(usr.id,'fd',dt,cls)}
      <Row>
        <Col className="col-6 pe-0">{renderSelectors(usr.id,'am',dt,cls)}</Col>
        <Col className="col-6 ps-0">{renderSelectors(usr.id,'pm',dt,cls)}</Col>
      </Row>
    </div>;
  };

  
  return (
    <>
      
          
      <Table rounded bordered responsive className="my-4">
        <thead>
          <tr>
            <th className="bg-dark p-3 text-white">User</th>
            {_.fill(new Array(props.mode===2 ? 7 : 1),1).map((s,i) => <th key={i} className="bg-primary text-center  text-white p-3" style={{minWidth: 350}}>{moment(dtFrom).add(i,'days').format("ddd DD")}</th>)}
          </tr>
        </thead>
        <tbody>
          {props.orgMembers().map((m,i) => <tr key={i}>
            <td className="bg-light text-dark">{renderMemberName(m)}</td>
            {_.fill(new Array(props.mode===2 ? 7 : 1),1).map((s,j) => <td key={j} className="text-center p-1">{renderMemberCell(m,moment(dtFrom).add(j,'days'))}</td>)}
          </tr>)}
        </tbody>
      </Table>
      {!saving && <div className="text-end">
        <Button type="button" variant="outline-secondary" className="py-3 px-4 mx-2" onClick={props.onHide}>Cancel</Button>
        <Button type="button" variant="primary" className="py-3 px-4" onClick={assignRotas}>Assign Rota</Button>
      </div>}

      {noteModal.show && <Modal show={noteModal.show} onHide={() => setNoteModal({show:false,uid:0,type:'',dtStr:''})} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Note</Modal.Title>
        </Modal.Header>
        <Form onSubmit={saveRotaNote}>
          <Modal.Body>
            <Form.Group className="mb-3" controlId="note">
              <Form.Label>Set Note</Form.Label>
              <Form.Control as="textarea" name="note" rows={3}>{_.get(rotas,[noteModal.uid,noteModal.type,noteModal.dtStr,'notes'],'')}</Form.Control>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setNoteModal({show:false,uid:0,type:'',dtStr:''})}>Close</Button>
            <Button variant="primary" type="submit">Save Note</Button>
          </Modal.Footer>
        </Form>
      </Modal>} 
    </>
  );
};

export default RotaAssignment;
